var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _AppContext_user;
export class AppContext {
    constructor(user) {
        _AppContext_user.set(this, void 0);
        __classPrivateFieldSet(this, _AppContext_user, user, "f");
    }
    get email() { return __classPrivateFieldGet(this, _AppContext_user, "f").Email; }
    get enabled() { return __classPrivateFieldGet(this, _AppContext_user, "f").Enabled; }
    get loginName() { return __classPrivateFieldGet(this, _AppContext_user, "f").LoginName; }
    get name() { return __classPrivateFieldGet(this, _AppContext_user, "f").Name; }
    get officeName() { return __classPrivateFieldGet(this, _AppContext_user, "f").Office; }
    get officeId() { return __classPrivateFieldGet(this, _AppContext_user, "f").OfficeId; }
    get position() { return __classPrivateFieldGet(this, _AppContext_user, "f").Position; }
    get profileId() { return __classPrivateFieldGet(this, _AppContext_user, "f").ProfileId; }
    get section() { return __classPrivateFieldGet(this, _AppContext_user, "f").Section; }
    get sectionBaseId() { return __classPrivateFieldGet(this, _AppContext_user, "f").SectionBaseId; }
    get dectionId() { return __classPrivateFieldGet(this, _AppContext_user, "f").SectionId; }
    get id() { return __classPrivateFieldGet(this, _AppContext_user, "f").UserId; }
    get externalUser() { return __classPrivateFieldGet(this, _AppContext_user, "f").ExternalUser; }
    get imageUrl() { return __classPrivateFieldGet(this, _AppContext_user, "f").imageUrl; }
    isMemberOf(...roleId) {
        return (__classPrivateFieldGet(this, _AppContext_user, "f").Roles || []).includes(0);
    }
}
_AppContext_user = new WeakMap();
